import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-teal-light py-11 sm:py-14" aria-labelledby="testimonials-title" data-id="element-162" data-mp="3kqw5io0qf8hp">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-163" data-mp="3fycp7jantz97">
        <h2 id="testimonials-title" className="text-center font-display text-[24px] font-semibold uppercase tracking-tightish text-navy-deep sm:text-3xl" data-id="element-164" data-mp="3b0udxm9677y1">
          From Speech Therapists using it
        </h2>

        <ul className="-mx-5 mt-6 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-1 no-scrollbar sm:mx-0 sm:mt-8 sm:grid sm:grid-cols-2 sm:gap-5 sm:overflow-visible sm:px-0" data-id="element-165" data-mp="31z3c4shr3l9g">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex w-[80vw] max-w-[340px] shrink-0 snap-center flex-col rounded-xl bg-ivory-light p-5 shadow-card sm:w-auto sm:max-w-none" data-id="element-166" data-mp="2s4303scedl1d">
              <QuoteIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-167" data-mp="h5yamk89jn69" />
              <blockquote className="mt-2.5 flex-1 text-[13.5px] leading-relaxed text-navy sm:text-[15px]" data-id="element-168" data-mp="h8181pbqwil0">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-4 flex items-center gap-3 border-t border-navy/10 pt-3" data-id="element-169" data-mp="79bnfosgsk12">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-light font-display text-[13px] font-semibold text-teal-dark" aria-hidden="true" data-id="element-170" data-mp="c7mwhxaxqqi8">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-171" data-mp="q63fonpzi9h9">
                  <p className="text-[12.5px] font-semibold uppercase tracking-[0.06em] text-navy-deep" data-id="element-172" data-mp="q4jx2qguvmcb">
                    {testimonial.name}
                  </p>
                  <p className="text-[11.5px] leading-tight text-navy-soft" data-id="element-173" data-mp="1iuigo6ca6r9l">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <p className="mt-3 text-center text-[10.5px] uppercase tracking-[0.14em] text-navy-soft/70" data-id="element-174" data-mp="1xfmul8274vu9">
          Sample layout content · to be replaced with customer feedback
        </p>
      </div>
    </section>;
}